module.exports = __webpack_public_path__ + "img/doya.88bd2384.png";